var classes = {"root":"q1PW5","gridColumnSpan":"LSXaq","gridColumnSpanSmall":"H62Zj","gridColumnFull":"vsBEc"};

export { classes as default };
